<template>
  <div class="thirdLogin">
    <p>正在跳转请稍后......</p>
  </div>
</template>

<script>
import { ajaxAPI } from '@/utils/ajaxUtil'
import {getUrlParam} from '@/common/js/utils'
import { HYBIRD_URL } from '@/config/url_config'
export default {
  name: 'thirdLogin',
  created () {
    console.log(getUrlParam('state'))
    this.goThirdLogin()
  },
  methods: {
    goThirdLogin() {
      let state = getUrlParam('state')
      let code = getUrlParam('code')
      // https://program-live.gaoxiaobang.com/#/thirdLogin?state=1511320149249_bd4c753a9dfe53847a0e02d9cdd4ef82&code=nsPtTawEfhcKPaV
      console.log(state)
      console.log(code)
      let url = `${HYBIRD_URL}/wanxiang/auth/token?code=${code}&state=${state}`
      ajaxAPI('GET', url).then(data => {
        console.log(data)
        if (data.data.status) {
          console.log(data.data.data)
          window.localStorage.setItem('accessToken', data.data.data.token)
          window.localStorage.setItem('userInfo', JSON.stringify(data.data.data))
          this.$router.push('ClassRoom')
        } else {
          alert('不好意思您未购买产品，请购买产品后再使用')
          window.location.href = 'http://wx.jcloud.com/'
        }
      }).catch(error => {
        console.log(error)
        alert('不好意思您未购买产品，请购买产品后再使用')
        window.location.href = 'http://wx.jcloud.com/'
      })
    }
  }
}
</script>

<style lang="scss">
  .thirdLogin{
    p{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #000;
      font-weight: 400;
    }
  }
</style>



// WEBPACK FOOTER //
// thirdLogin.vue?78943881